module.exports = __webpack_public_path__ + "static/media/energy-flexibility-simulator-img-003.fb74307d.jpg";